import produce from "immer"
import { ASC, PENDING } from "const"
import { MtTask } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initTask: MtTask = {
    id: null,
    taskId: null,
    accountId: null,
    projectId: null,
    phaseId: null,
    name: "",
    description: "",
    creator: null,
    responsible: null,
    deadline: null,
    highPriority: false,
    status: PENDING,
    statusChanged: null,
}

const initTaskState: types.TaskState = {
    baseRoute: null,
    showColumnSettings: false,
    onSelect: null,
    selected: null,

    taskList: {},
    taskGroupedIds: {},
    taskSort: {},
    filters: {
        name: "",
        projectId: null,
        creator: null,
        responsible: null,
        deadline: null,
        highPriority: false,
        status: {
            pending: false,
            inProgress: false,
            pendingReview: false,
            completed: false,
            deferred: false,
        },
        search: null,
    },

    taskEdit: initTask,
    attachmentsEdit: [],
    taskProjectGroupedListEdit: {},
    taskProjectGroupedIdsEdit: {},
    lifecyclePhaseListEdit: {},
    lifecyclePhaseIdsEdit: {},
    reloadEdit: true,

    attachmentsView: {},

    // popup menu
    active: null,
    menuShow: false,
    menuTarget: null,

    delegateUsers: {
        userIds: [],
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: [],
    },
}

const taskReducer = produce((
    draft: types.TaskState = initTaskState,
    action: ActionTypes = null,
): types.TaskState => {
    switch (action.type) {
        case types.TASK_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.TASK_COLUMN_SETTINGS:
            draft.showColumnSettings = action.show
            return draft

        case types.TASK_ON_SELECT:
            draft.onSelect = action.onSelect
            return draft

        case types.TASK_SELECTED:
            draft.selected = action.selected
            return draft

        case types.TASK_LIST:
            draft.taskList = action.taskList
            return draft

        case types.TASK_GROUPED_IDS:
            draft.taskGroupedIds = {
                ...draft.taskGroupedIds,
                ...action.taskGroupedIds,
            }
            return draft

        case types.TASK_SORT:
            draft.taskSort = {
                ...draft.taskSort,
                ...action.sort,
            }
            return draft

        case types.TASK_FILTERS:
            draft.filters = action.filters
            return draft

        case types.TASK_EDIT:
            draft.taskEdit = action.task
            return draft

        case types.TASK_ATTACHMENTS_EDIT:
            draft.attachmentsEdit = action.attachments
            return draft

        case types.TASK_PROJECT_GROUPED_LIST_EDIT:
            draft.taskProjectGroupedListEdit = action.taskProjectGroupedList
            return draft

        case types.TASK_PROJECT_GROUPED_IDS_EDIT:
            draft.taskProjectGroupedIdsEdit = action.taskProjectGroupedIds
            return draft

        case types.TASK_LIFECYCLE_PHASE_LIST_EDIT:
            draft.lifecyclePhaseListEdit = action.phaseList
            return draft

        case types.TASK_LIFECYCLE_PHASE_IDS_EDIT:
            draft.lifecyclePhaseIdsEdit = action.phaseIds
            return draft

        case types.TASK_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        case types.TASK_ATTACHMENTS_VIEW:
            draft.attachmentsView = {
                ...draft.attachmentsView,
                ...action.attachments,
            }
            return draft


        // popup menu
        case types.TASK_ACTIVE:
            draft.active = action.active
            return draft

        case types.TASK_POPUP_MENU_SHOW:
            draft.menuShow = action.show
            return draft

        case types.TASK_POPUP_MENU_TARGET:
            draft.menuTarget = action.target
            return draft


        case types.TASK_DELEGATE_USER_IDS:
            draft.delegateUsers.userIds = action.userIds
            return draft

        case types.TASK_DELEGATE_SORT:
            draft.delegateUsers.sortColumn = action.sortColumn
            draft.delegateUsers.sortOrder = action.sortOrder
            return draft

        case types.TASK_DELEGATE_FILTERS:
            draft.delegateUsers.filters = action.filters
            return draft

        case types.TASK_DELEGATE_SELECTED:
            draft.delegateUsers.selected = action.selected
            return draft

        default:
            return draft
    }
})
export default taskReducer
